export default __webpack_public_path__ + "static/media/contacts.3fc04790.svg";